let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hLcol")).then(() => parcelRequire('eU6sn'));